import styles from "./index.module.css";
import "swiper/css";
import ArrowRightIcon from "../Icon/ArrowRightIcon";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MiniGameCard from "./MiniGameCard";

const MiniGame = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const data = [
    {
      image: "/images/mini-game-2048.webp",
      name: "2048",
      description: t("miniGames.game2048Description"),
      path: "/mini-games2048",
    },
    {
      image: "/images/mini-game-match3.webp",
      name: "Trio da Sorte",
      description: t("miniGames.gameMatch3Description"),
      path: "/mini-games-match3",
    },
  ];
  return (
    <div className={styles.miniGame}>
      <div className={`${styles.title} flex-row`}>
        <div className={styles.titleText}>{t("miniGames.waitingForDrawing")}</div>
        <div
          className={`${styles.allGames} flex-right`}
          onClick={() => navigate("/mini-games")}
        >
          {t("games.allGames")} <ArrowRightIcon size="12px" />
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {data.map((game, idx) => (
          <MiniGameCard key={idx} game={game} onClick={() => navigate(game.path)} />
        ))}
      </div>
    </div>
  );
};

export default MiniGame;
